import { getDownloadSelectors, getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const operationsMasterListSelector = getSelectors({
  getRootPath: selectorsConfig.operationsMasterListSelector.getRootPath,
})

export const operationsMasterListDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.operationsMasterListDownloadSelector.getRootPath,
})

export const bankingProductMovementsDataSelector = getSelectors({
  getRootPath: selectorsConfig.bankingProductMovementsDataSelector.getRootPath,
})

export const bankingProductMovementsDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.bankingProductMovementsDownloadSelector.getRootPath,
})
export const bankingProductLoanReceiptsDataSelector = getSelectors({
  getRootPath: selectorsConfig.bankingProductLoanReceiptsDataSelector.getRootPath,
})
export const bankingProductLoanReceiptsDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.bankingProductLoanReceiptsDownloadSelector.getRootPath,
})
